<div class="console-view" [style.height.px]="contentHeight()">
  <!-- Filter Bar -->
  <div class="filter-bar">
    <div class="filter-controls">
      <span class="filter-label">Filter by</span>

      <button
        class="filter-badge"
        [class.active]="filters().error"
        (click)="toggleFilter('error')"
      >
        <span class="badge-icon error">⊗</span>
        <span class="badge-count">{{ errorCount() }}</span>
      </button>

      <button
        class="filter-badge"
        [class.active]="filters().api"
        (click)="toggleFilter('api')"
      >
        <span class="badge-icon success">✓</span>
        <span class="badge-count">{{ apiCount() }}</span>
      </button>

      <button
        class="filter-badge"
        [class.active]="filters().warn"
        (click)="toggleFilter('warn')"
      >
        <span class="badge-icon warning">⚠</span>
        <span class="badge-count">{{ warnCount() }}</span>
      </button>

      <button
        class="filter-badge"
        [class.active]="filters().info"
        (click)="toggleFilter('info')"
      >
        <span class="badge-icon info">☐</span>
        <span class="badge-count">{{ infoCount() }}</span>
      </button>

      <!-- <label class="checkbox-label">
        <input
          type="checkbox"
          [checked]="showTimestamp()"
          (change)="showTimestamp.set(!showTimestamp())"
        />
        Show timestamp
      </label> -->
    </div>

    <div class="search-container">
      <div class="search-container-left">
        <span class="search-icon fa fa-search"></span>
        <input
          type="text"
          placeholder="Search"
          [value]="searchQuery()"
          (input)="searchQuery.set($any($event.target).value)"
          class="search-input"
        />
      </div>
      <button
        class="clear-btn"
        (click)="clearLogs()"
        title="Clear console"
      >
        <span class="fa fa-ban"></span>
      </button>

      <!-- Help Icon with Hover Tooltip -->
      <div class="help-container">
        <span class="help-icon fa fa-question-circle"></span>

        <!-- Help Tooltip (appears on hover) -->
        <div class="help-tooltip">
          <!-- Header -->
          <div class="tooltip-header">
            <div class="header-content">
              <div>View real-time logs and debug your application.<br>Execute JavaScript with full TabSDK access.</div>
            </div>
          </div>

          <!-- Body -->
          <div class="tooltip-body">
            <!-- JavaScript Commands Section -->
            <div class="tooltip-section">
              <div class="section-title">JAVASCRIPT COMMANDS</div>
              <div class="section-content">
                <div class="api-row">
                  <span class="api-code">alert('message')</span>
                  <span class="api-label">– Show alert dialog</span>
                </div>
                <div class="api-row">
                  <span class="api-code">console.log('value')</span>
                  <span class="api-label">– Log to console</span>
                </div>
                <div class="api-row">
                  <span class="api-code">console.error('error')</span>
                  <span class="api-label">– Show error</span>
                </div>
              </div>
            </div>

            <!-- Available APIs Section -->
            <div class="tooltip-section">
              <div class="section-title">TABSDK APIS</div>
              <div class="section-content">
                <div class="api-row">
                  <span class="api-code">TabSdk.state</span>
                  <span class="api-label">– Access screens, components, queries</span>
                </div>
                <div class="api-row">
                  <span class="api-code">TabSdk.store</span>
                  <span class="api-label">– Access browser storage</span>
                </div>
              </div>
            </div>

            <!-- Quick Examples Section -->
            <div class="tooltip-section">
              <div class="section-title">QUICK EXAMPLES</div>
              <div class="section-content examples-grid">
                <div class="example-code">alert('Hello World')</div>
                <div class="example-code">Object.keys(TabSdk.state.global)</div>
                <div class="example-code">[1,2,3].reduce((a,b) => a+b)</div>
                <div class="example-code">TabSdk.state.global.User</div>
                <div class="example-code">TabSdk.store.appId</div>
              </div>
            </div>

            <!-- Footer -->
            <div class="tooltip-footer">
              <span class="footer-icon">💡</span>
              <span class="footer-label">Use filters (⊗ / ✓ / ⚠ / ☐) to organize logs</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Splitter between Logs and Input -->
  <ejs-splitter height='calc(100% - 40px)' separatorSize=2 width='100%' orientation='Vertical'>
    <e-panes>
      <!-- Console Logs Pane -->
      <e-pane size='85%' min='100px'>
        <ng-template #content>
          <div class="console-logs">
            <div class="logs-container">
              @for (log of filteredLogs(); track log.id) {
                <div
                  class="log-line"
                  [class]="'log-' + log.type"
                  [class.expandable]="log.isJsonData"
                >
                  <!-- Expand Arrow - only for non-empty JSON data -->
                  @if (log.isJsonData) {
                    <span
                      class="expand-arrow"
                      (click)="toggleExpand(log.id)"
                    >
                      {{ log.isExpanded ? '▼' : '▶' }}
                    </span>
                  }

                  <!-- Status Icon - Only for error, warn (not API errors which have their own icon) -->
                  @if (log.type === 'error' && !log.queryName) { <span class="log-icon icon-error">⊗</span> }
                  @if (log.type === 'warn') { <span class="log-icon icon-warn">⚠</span> }

                  <!-- Log Message -->
                  <div class="log-content">
                    <span
                      class="log-message"
                      [class.clickable]="log.isJsonData"
                      (click)="log.isJsonData ? onMessageClick(log.id) : null"
                    >
                      {{ log.message }}
                    </span>

                    <!-- INLINE PREVIEW for JSON-like data -->
                    @if (log.inlinePreview) {
                      <span
                        class="log-preview"
                        [class.clickable]="log.isJsonData"
                        (click)="log.isJsonData ? onMessageClick(log.id) : null"
                      > {{ log.inlinePreview }} </span>
                    }

                    <!-- Expanded JSON Tree -->
                    @if (log.isExpanded && log.isJsonData) {
                      <div class="log-data-expanded">
                        <app-json-tree
                          [data]="log.data"
                          [searchQuery]="searchQuery()"
                        />
                        @if (log.blobPreviewUrl) {
                          <div class="blob-preview-container">
                            <img class="blob-preview-img" [src]="log.blobPreviewUrl" alt="Response preview" />
                          </div>
                        }
                      </div>
                    }
                  </div>

                  <!-- Query Badge (right side) -->
                  @if (log.queryName) {
                    <div class="log-badge">
                      <span class="query-badge">{{ log.queryName }}</span>
                    </div>
                  }
                </div>
              }

              @if (filteredLogs().length === 0) {
                <div class="empty-state">
                  <div class="empty-icon">💬</div>
                  <div class="empty-text">No console logs.</div>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </e-pane>

      <!-- Console Input Pane -->
      <e-pane size='15%' min='50px'>
        <ng-template #content>
          <div class="console-input-bar">
            <span class="input-prompt">›</span>
            <input
              type="text"
              [(ngModel)]="command"
              (keydown.enter)="executeCommand()"
              (keydown.arrowUp)="navigateHistory(-1)"
              (keydown.arrowDown)="navigateHistory(1)"
              placeholder="Enter JavaScript code"
              class="command-input"
            />
          </div>
        </ng-template>
      </e-pane>
    </e-panes>
  </ejs-splitter>
</div>